<template>
    <AuthLayout>
        <Head :title="$t('Registration Pending')" />
        <GlobalLoadingOverlay />

        <div class=" flex items-center justify-center bg-gray-50 py-2 px-4 sm:px-6 lg:px-8">
            <div class="max-w-md w-full space-y-8">
                <div class="text-center">
                    <img class="mx-auto h-12 w-auto" :src="logoUrl" alt="Linkarme" />
                    <h1 class="mt-6 text-3xl font-bold text-gray-900">
                        {{ $t('Verify your email') }}
                    </h1>
                    <p class="mt-2 text-sm text-gray-600">
                        {{ $t('Registration pending confirmation') }}
                    </p>

                    <!-- <div class="mt-6 flex justify-center">
                      <SelectLanguage />
                    </div> -->
                </div>

                <div class="mt-8 space-y-6">
                    <div class="bg-blue-50 border border-blue-200 rounded-lg p-6">
                        <div class="flex">
                            <div class="flex-shrink-0">
                                <svg class="h-8 w-8 text-blue-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                                          d="M3 8l7.89 7.89a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                </svg>
                            </div>
                            <div class="ml-4">
                                <h3 class="text-lg font-medium text-blue-900">
                                    {{ $t('Confirmation email sent!') }}
                                </h3>
                                <div class="mt-2 text-blue-800">
                                    <p class="mb-3">
                                        {{ $t('We have sent a confirmation email to the address you provided. To activate your account, please click the link we sent.') }}
                                    </p>
                                    <ul class="list-disc list-inside text-sm space-y-1">
                                        <li>{{ $t('Check your inbox') }}</li>
                                        <li>{{ $t('Don\'t forget to check your spam/junk folder') }}</li>
                                        <li>{{ $t('The confirmation link expires in 24 hours') }}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
                        <div class="flex">
                            <div class="flex-shrink-0">
                                <svg class="h-5 w-5 text-yellow-400" viewBox="0 0 20 20" fill="currentColor">
                                    <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
                                </svg>
                            </div>
                            <div class="ml-3">
                                <p class="text-sm text-yellow-800">
                                    <strong>{{ $t('Important:') }}</strong> {{ $t('Your account will only be activated after email confirmation. If you don\'t receive the email in a few minutes, please check your spam folder.') }}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="flex flex-col space-y-3">
                        <Link :href="route('client.login')" 
                              class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                            {{ $t('Go to Login') }}
                        </Link>
                    </div>
                </div>

                <!-- <div class="text-center">
                    <p class="text-xs text-gray-500">
                        {{ $t('Problems with registration? Contact us') }}
                    </p>
                </div> -->
            </div>
        </div>
    </AuthLayout>
</template>

<script setup>
import { getCurrentInstance } from 'vue';
import { Head, Link } from '@inertiajs/vue3';
import AuthLayout from "@/layout/auth/AuthLayout.vue";
import GlobalLoadingOverlay from '@/components/GlobalLoadingOverlay.vue';
import logoUrl from '@/assets/login-logo.png';
import SelectLanguage from '../../components/SelectLanguage.vue';

const { proxy } = getCurrentInstance();
const $t = proxy.$t;
</script>